export const ClientsOverview = ({
  primaryFontColor = "var(--primary-bg-color)",
  color = "var(--primary-background-text-color",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.067"
      height="24.564"
      viewBox="0 0 25.067 24.564"
    >
      <g id="dashboard" transform="translate(-2.5 -3.45)">
        <path
          id="Path_65836"
          data-name="Path 65836"
          d="M13.964,54.672a1.7,1.7,0,0,0-1.7-1.7H4.2a1.7,1.7,0,0,0-1.7,1.7v7.245a2.552,2.552,0,0,0,2.551,2.551h7.211a1.7,1.7,0,0,0,1.7-1.7Z"
          transform="translate(0 -36.455)"
          fill={primaryFontColor}
        />
        <path
          id="Path_65837"
          data-name="Path 65837"
          d="M63.716,52.97H55.622a1.7,1.7,0,0,0-1.7,1.7v8.095a1.7,1.7,0,0,0,1.7,1.7h7.245a2.552,2.552,0,0,0,2.551-2.551V54.672A1.7,1.7,0,0,0,63.716,52.97Z"
          transform="translate(-37.853 -36.455)"
          fill={primaryFontColor}
        />
        <path
          id="Path_65838"
          data-name="Path 65838"
          d="M25.014,3.45H5.051A2.552,2.552,0,0,0,2.5,6v7.211a1.7,1.7,0,0,0,1.7,1.7H25.866a1.7,1.7,0,0,0,1.7-1.7V6A2.555,2.555,0,0,0,25.014,3.45Z"
          transform="translate(0 0)"
          fill={primaryFontColor}
        />
      </g>
    </svg>
  );
};
